import { useDispatch } from 'react-redux';

import Text from '../../shared/uiComponents/Text';

import { sortByTime } from './Helpers/functions';
import { DayProperties } from './Helpers/interfaces';
import { weeks } from './Helpers/constants';
import Session from './Session';
import SessionHeader from './Session/sessionHeader';

import { DispatchProperties, useSelector } from '../../redux/store';
import { SoapNotesStatuses } from '../../redux/API/ClientAPIHelpers/dataCollectionProperties';
import { goToNextMonth, goToPreviousMonth, setSelectedDay } from '../../redux/State/clientSlice/calendarHelperSlice';
import { useScreenWidth } from '../../shared/Helpers/hooks';
import { useSwipe } from './hooks/useSwipe';

const MonthView = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	const showCompletedSession = useSelector((state) => state.calendarHelper.filterData.showCompleted);
	const showDraftsOnly = useSelector((state) => state.calendarHelper.filterData.showDraftsOnly);
	const days = useSelector((state) => state.calendarHelper.displayedCalendarPageDays);
	const events = useSelector((state) => state.calendar.events);
	const swipeHandlers = useSwipe({
		onSwipeLeft: () => {
			if (isMobile) {
				dispatch(goToNextMonth());
			}
		},
		onSwipeRight: () => {
			if (isMobile) {
				dispatch(goToPreviousMonth());
			}
		},
	});

	const daysMapper = (item: DayProperties, index: number) => {
		// eslint-disable-next-line
		const selectDayHandler = (item: DayProperties) => {
			dispatch(setSelectedDay(item));
		};

		return (
			<div key={index} className="day" onClick={() => selectDayHandler(item)}>
				<SessionHeader item={item} dayIndex={index} />
				<div className="sessionWrapper">
					{events &&
						events.length > 0 &&
						[...events]
							.sort((a, b) => sortByTime({ a, b }))
							.filter((x) =>
								showCompletedSession ? x.isCompleted && x.reportStatus?.status === SoapNotesStatuses.submitted : true,
							)
							.filter((x) => (showDraftsOnly ? x.reportStatus?.status === SoapNotesStatuses.draft : true))
							.map(
								(res) =>
									new Date(res.startTime).getUTCDate() === item.day &&
									new Date(res.startTime).getUTCMonth() === item.month && <Session key={res.id} event={res} />,
							)}
				</div>
			</div>
		);
	};

	const weekNameTitleHandler = (weekName: string) => {
		if (!isMobile) return weekName;

		return weekName.slice(0, 2);
	};

	return (
		<div className="monthView" {...(isMobile ? swipeHandlers : {})}>
			<div className="headers">
				{weeks.map((day, index) => (
					<Text
						key={index}
						title={weekNameTitleHandler(day)}
						type={isMobile ? 'pxs' : 'psm'}
						fontWeight="medium"
						className="header"
					/>
				))}
			</div>
			<div className="daysWrapper">{days.map(daysMapper)}</div>
		</div>
	);
};

export default MonthView;
